function addItemToBasket() {
    var $ = jQuery;

    ecw_show_loading();

    // console.log("add item ?");

    var productSelections = {
        chainproductid: Number(
            $("#item-add-to-cart").attr("data-menu-selection-chain-id")
        ),
        quantity: Number($("input#product-item-qty").val()),
        choices: [],
        recipient: $("#item-customer-name").val(),
    };

    // console.log('chainproductid', Number($("input#product-item-qty").val()));

    var $productView = $("#product-detail-view");

    var productVariant = [];

    // Get Primary Choices

    $productView.find("input[data-item-selector]:checked").each(function () {
        var choiceQty = 1;
        var choiceID = $(this).attr("id");
        var chainOptionID = $(this).attr("data-chainoptionid");

        let quantitySelector = parseInt(
            $(this).siblings('.quantity-container:not(.option-hide)').find('input.qtyinput').val(),
            10
        ) || 0;

        if (quantitySelector !== 0) {
            choiceQty = quantitySelector;
            // console.log('choiceQty', choiceQty, ' ', choiceID);
        }

        // Only proceed if a chain option ID is present
        if (chainOptionID) {

            var choice = {
                name: $('label[for="' + choiceID + '"] strong').text(),
                chainchoiceid: chainOptionID,
                quantity: choiceQty,
            };

            if (!$(this).is("[data-item-selector-modifier]")) {
                productSelections.choices.push(choice);
            }

            var modChoices = getSelectedModifiers($(this).attr('id'));

            if (modChoices.length) {
                choice.choices = modChoices;
            }
        }
    });

    // console.log(productVariant);

    var itemPrice = Number(
        $("#item-add-to-cart")
            .find("[data-item-selection-price]")
            .text()
            .replace("$ ", "")
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    var addToCartData = {
        event: "add_to_cart",
        ecommerce: {
            currency: "USD",
            value: itemPrice,
            items: [
                {
                    item_id: $("#item-add-to-cart").attr("data-menu-selection-id"),
                    item_name: $("#product-detail-view")
                        .find("[data-product-view-title]:first")
                        .text(),
                    affiliation: localStorage.getItem(
                        "ecw_customer_store_location_name"
                    ),
                    price: itemPrice,
                    item_variant: productVariant.join(", "),
                    quantity: Number($("input#product-item-qty").val()),
                },
            ],
        },
    };
    const hasExtraCookieConsent = checkNonNecessaryConsent();
    if (hasExtraCookieConsent) {
        // console.log("GA4:", addToCartData);
        window.dataLayer.push(addToCartData);
    }


    // console.log(JSON.stringify(productSelections));
    // return;

    // console.log('productSelections', JSON.stringify(productSelections));
    // console.log('ecw_customer_basket_id', localStorage.getItem('ecw_customer_basket_id'));

    $.ajax({
        type: 'POST',
        url: ajax_url,
        data: {
            action: 'olo_add_to_basket',
            productSelections: JSON.stringify(productSelections),
            basketGuid: localStorage.getItem('ecw_customer_basket_id'),
            referer: window.location.href,

        },
        success: function (response) {
            // console.log(response);
            // console.log(JSON.parse(response));
            var result = JSON.parse(response);

            if ('code' in result) {
                ecw_hide_loading();
                console.log('error ', result.message);
                $('[data-add-to-cart-message]').text(result.message);
                $('[data-add-to-cart-message]').removeClass('hide');
                if (result.code == 10) {
                    console.log('basket error.');

                    const $modal = $('#add-to-basket-error-fail');

                    // Initialize Reveal manually
                    const modalInstance = new Foundation.Reveal($modal);

                    // Bind event
                    $modal.off('closed.zf.reveal').on('closed.zf.reveal', function () {
                        console.log('i close');
                        clearBasketSession();
                        change_view("start-order");
                    });

                    // Open it
                    modalInstance.open();

                }

            } else {
                // console.log('updateBasketDisplay #4 ');

                $('[data-add-to-cart-message]').addClass('hide');
                // Close menu selection modal
                //   $('#shopping-cart-view').foundation('open');
                // Reset the current state to the menu view
                //   if (window.location.hash !== '#menu-product-view') {
                //     history.replaceState({}, '', window.location.pathname + '#menu');
                //   }
                $.when(

                    updateBasketDisplay(true)
                ).done(function () {
                    ecw_hide_loading();
                });
            }
        },
        complete: function () {

        }
    });
}
function orderingViewPDP(selectedItem, editBasketItem) {
    var $ = jQuery;
    $contentContainer.load(templateRoot + "wf-ordering-menu-pdp.html", function () {
        // console.log('show PDP info');
        ecw_show_loading();

        // Set Nutrition Document URL
        // console.log('nutritionDocumentURL', nutritionDocumentURL)
        $('[data-nutrition-document]').attr('href', nutritionDocumentURL);
        // Preflight: set all qty values
        $("input#product-item-qty").val("1");
        $("input#product-item-qty").attr("min", "1");
        $("input#product-item-qty").attr("max", "99");
        $("input#product-item-qty").attr("step", "1");

        // Preflight: set ids to be used
        var productId = selectedItem.attr("data-menu-selection-id");
        var chainProductId = selectedItem.attr("data-menu-selection-chain-id");
        var productCost = selectedItem.attr("data-menu-selection-cost");

        // Preflight: set min/max/increment for qty selector
        var productMinQty = selectedItem.attr("data-minimum-quantity");
        var productMaxQty = selectedItem.attr("data-maximum-quantity");
        var productIncrement = selectedItem.attr("data-quantity-increment");

        if (productMinQty) {
            $("input#product-item-qty").attr("min", productMinQty);
            $("input#product-item-qty").val(productMinQty);
        }
        if (productMaxQty) {
            $("input#product-item-qty").attr("max", productMaxQty);
            // console.log('i small boy', productMaxQty);
        }
        if (productIncrement) {
            $("input#product-item-qty").attr("step", productIncrement);
        }

        // Preflight: set qty element
        setQuantityElem(
            $("#product-quantity-selector"),
            $("input#product-item-qty").attr("min"),
            $("input#product-item-qty").attr("max"),
            $("input#product-item-qty").attr("step")
        );

        $("[data-menu-item-detail-image]").attr("src", selectedItem.attr("data-menu-image-url"));
        $("a.menu-category-url").attr("href", "/order/" + selectedItem.attr("data-menu-category-url"));
        $("[data-button-label]").text(selectedItem.attr("data-menu-category"));

        //look for image in image array with group name 'web detail' for product details header image
        // if (menu.imagepath && menu_item.images.find(image => image.groupname === 'web-detail')) {
        //   $('[data-menu-item-detail-image]').attr('src', menu.imagepath + menu_item.images.find(image => image.groupname === 'web-detail').filename);
        // } else {
        //   // No image associated -- Show Placeholder
        //   $('[data-menu-item-detail-image]').attr('src', '/wp-content/themes/East Coast Wings/assets/images/ecw-product-placeholder.svg');
        // } 
        var $detailView = $("#product-detail-view");

        $detailView.find("[data-product-view-title]").text(selectedItem.find("[data-menu-item-title]").text());
        if (selectedItem.find("[data-menuitemlabels]").html()) {
            $detailView.find("[data-menuitemlabels").html(selectedItem.find("[data-menuitemlabels]").html());
        } else {
            $detailView.find("[data-menuitemlabels").remove();
        }
        
        if (selectedItem.find("[data-menuitemtags]:not(.hide)").html()) {
            $detailView.find("[data-menuitemtags]").html(selectedItem.find("[data-menuitemtags]").html());
            $detailView.find("[data-menuitemtags]").removeClass('hide');
        } else {
            $detailView.find("[data-menuitemtags]").addClass('hide');
        }
        $detailView
            .find("[data-product-total-calories]")
            .text(selectedItem.find("[data-menu-item-calories]").text());
        // Set the text from data-menu-item-desc to data-product-view-description
        let menuItemDesc = selectedItem.find("[data-menu-item-desc]").text();
        $detailView.find("[data-product-view-description]").text(menuItemDesc);

        // Check if data-menu-item-desc has no text and hide the element if necessary
        if ($.trim(menuItemDesc) === "") {
            // Add class 'hide' to data-main-ingredients-with-no-custumization if there is no text
            $detailView.find("[data-main-ingredients-with-no-custumization]").css('display', 'none');
        } else {
            // Remove the 'hide' class if there's text, in case you want to toggle it
            $detailView.find("[data-main-ingredients-with-no-custumization]").css('display', 'block');
        }

        $detailView.find("#item-add-to-cart").attr("data-menu-selection-id", productId);
        // console.log('productId', $detailView.find("#item-add-to-cart"));
        $detailView.find("#item-add-to-cart").attr("data-menu-selection-chain-id", chainProductId);
        //hide quantiy if max quanitiy is 1 
        // console.log('Maximum quantity:', $(this).attr('data-maximum-quantity'));
        if (Number($(this).attr('data-maximum-quantity')) === 1) {
            $('.add-to-cart-qty').addClass('hide');
        } else {
            $('.add-to-cart-qty').removeClass('hide');
        }
        //end
        var $basePrice = $detailView.find("[data-base-price]");

        $basePrice.find('input[type="checkbox"]').attr("id", productId);
        $basePrice.find('input[type="checkbox"]').attr("data-cost", productCost);
        $basePrice.find('input[type="checkbox"]').attr("chainproductid", chainProductId);
        // $basePrice.find('input[type="checkbox"]').val(productCost);
        $basePrice.find("label").attr("for", productId);
        $basePrice
            .find("label")
            .text(
                $(this).find("[data-menu-item-title]").text() + " Base Price"
            );

        $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
                action: "get_olo_get_menu_options",
                productId: productId,
                referer: window.location.href
            },
            success: function (response) {
                // Detect Safari
                function isSafari() {
                    const ua = navigator.userAgent;
                    return /^((?!chrome|android).)*safari/i.test(ua);
                }
                function isIOS() {
                    return /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
                        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                }

                if (isSafari() || isIOS()) {
                    $('.wf-ordering-container').addClass('safari-browser');
                } else {
                    $('.wf-ordering-container').removeClass('safari-browser');
                }
                // console.log('menu PDP', JSON.parse(response));
                if (localStorage.getItem('ecw_customer_group_order_user_type') === "notHost") {
                    // console.log('no host');
                    $('.item-customer-name-wrapper').addClass('hide');
                } else {
                    // console.log('yes host'); 
                    $('.item-customer-name-wrapper').removeClass('hide');
                }
                // console.log("load product options");

                clearProductOptions();

                var optionGroups = JSON.parse(response).optiongroups;

                var $productDetails = $("#product-detail-view");


                $.each(optionGroups, function (index, group) {
                    setItemOptions(group);
                }); // $.each(optionGroups ...

                calculateProductTotal();
                $("#product-item-qty").change(function () {
                    calculateProductTotal();
                    console.log('calculate total');
                });
                if (
                    localStorage.getItem('ecw_customer_group_order_user_type') === "host"
                ) {
                    $('input#item-customer-name').val(localStorage.getItem('ecw_customer_host_group_order_name') + ' (You)');
                } else if (localStorage.getItem('ecw_customer_group_order_name') && localStorage.getItem('ecw_customer_group_order_user_type') === "notHost") {
                    $('input#item-customer-name').val(localStorage.getItem('ecw_customer_group_order_name'));
                }
                // Product Option / Modifier UI
                $("[data-product-option-group]").each(function () {
                    $(this)
                        .find(
                            "input[data-item-selector], input[data-item-selector-modifier], input.qtyinput"
                        )
                        .change(function () {

                            // Validate Form
                            let $inputElementForComboMeal = $('fieldset.heat-indexes input');
                            let inputChanged = $(this);

                            if ($(this).is($inputElementForComboMeal)) {
                                // Pass comboChange as true
                                // console.log('ahhh', $(this)); 
                                validateItemForm(true, $(this));
                            } else {
                                // Pass comboChange as false
                                validateItemForm(false, $(this));
                                // console.log('ahhh!', $(this));

                            }
                            // Calculate Total
                            calculateProductTotal();
                        });
                });

                // If the product is being viewed in edit mode
                if (editBasketItem) {
                    ecw_show_loading();

                    $.ajax({
                        type: "POST",
                        url: ajax_url,
                        data: {
                            action: "olo_get_basket",
                            basketGuid: localStorage.getItem(
                                "ecw_customer_basket_id"
                            ),
                            referer: window.location.href,

                        },
                        success: function (response) {
                            // console.log(response);
                            // console.log(JSON.parse(response));
                            var result = JSON.parse(response);

                            var basketProducts = result.products;

                            $.each(basketProducts, function (key, bProduct) {
                                if (bProduct.id == editBasketItem) {
                                    $.each(bProduct.choices, function (key, choice) {
                                        // Select products
                                        $("#" + choice.optionid).click();
                                        $("#" + choice.optionid).prop('checked', true);
                                        // console.log('choice.optionid', choice.optionid, choice.name);

                                        // Set quantities
                                        $(
                                            'input[type="radio"][data-qty-for="' +
                                            choice.optionid +
                                            '"][value="' +
                                            choice.quantity +
                                            '"]'
                                        ).click();
                                        $(
                                            'input[type="number"][data-qty-for="' +
                                            choice.optionid +
                                            '"]'
                                        )
                                            .val(choice.quantity)
                                            .change();

                                    });
                                    // Set customer Name
                                    $("#item-customer-name").val(bProduct.recipient);
                                    // Set Quantity
                                    $("input#product-item-qty")
                                        .val(bProduct.quantity)
                                        .change();
                                    return;
                                }
                            });

                            $detailView
                                .find("#item-add-to-cart-update")
                                .attr("data-update-product-id", editBasketItem);
                            // $detailView.find('#item-add-to-cart-update').attr('data-update-product-id', productId);

                            $detailView.find("#item-add-to-cart").addClass("hide");
                            $detailView
                                .find("#item-add-to-cart-update")
                                .removeClass("hide");

                            ecw_hide_loading();
                            //scroll to combo info 
                            // if (localStorage.getItem('scrollToComboModifier') === 'true') {
                            //     // console.log('Scroll flag is set. Trying to scroll...');
                            //     $('fieldset.highlight').each(function () {
                            //         let $fieldset = $(this);
                            //         let $inputElement = $fieldset.find('span:nth-of-type(2) input');
                            //         $inputElement.prop('checked', true);
                            //     });

                            //     // let productChoices = JSON.parse(localStorage.getItem('scrollToComboModifierOptions'));
                            //     // Find the object with name 'No'
                            //     // const noChoice = productChoices.find(choice => choice.name.toLowerCase() === 'small');
                            //     // if (noChoice) {
                            //     //   console.log('no Choice', noChoice.optionid);  

                            //     //   // Find the input element with ID matching noChoice.optionid
                            //     //   const $inputElement = $("#" + noChoice.optionid);
                            //     //   console.log('sdgsdgs', $inputElement.parent().parent().find('legend'))

                            //     // }


                            //     // $('fieldset.size-selector').each(function () {
                            //     //   let $fieldset = $(this);
                            //     //   let $inputElement = $fieldset.find('span:nth-of-type(3) input');
                            //     //   $inputElement.prop('checked', true);
                            //     // }); 
                            //     // Remove the flag from localStorage after scrolling
                            //     validateItemForm(true);
                            //     localStorage.removeItem('scrollToComboModifier');
                            // }

                            //end of scroll to combo info 
                            // Reset URL to prevent backout collisions
                            // history.replaceState({}, "", "#menu-product-view");
                            editBasketItem = 0;
                        },
                        complete: function () { },
                    });
                } else {
                    $detailView.find("#item-add-to-cart").removeClass("hide");
                    $detailView.find("#item-add-to-cart-update").addClass("hide");
                }
            },
            complete: function () {
                if (!editBasketItem) {
                    ecw_hide_loading();
                }
                // $detailView.foundation("open");
                // console.log('open product view');

                $('#product-detail-view').animate({ scrollTop: 0 }, 500); // Scroll to top
                // $detailView.find('.product-detail-view-wrap').css({
                //   'padding-bottom': $('#floating-add-to-cart').outerHeight()
                // });

                // Add a layer in history to allow back button to close modal
                // if (window.location.hash !== "#menu-product-view" && editBasketItem == 0) {
                //     history.pushState({}, "", "#menu-product-view");
                // }
                //select defualt options 
                $(
                    "[data-product-options] input[data-item-selector], [data-modifier-group] input[data-item-selector-modifier], [data-modifier-group-for-fake-dropdown] input[data-item-selector-modifier], [main-ingredient-customizer-information-popup] input[data-item-selector-modifier]"
                ).each(function () {
                    if ($(this).attr('radiodefualtcheckedstate') === 'true') {
                        if ($(this).is($('[main-ingredient-customizer-information-popup] input[data-item-selector-modifier]'))) {
                            // console.log($(this), 'hjfjhf'); 
                        }
                        $(this).prop('checked', true);
                        $(this).parent().addClass("selected");
                    }
                });
                validateItemForm();
                calculateProductTotal();

                //end of combo popup alert JS functionality
                // undoConditionFormattingChanges when click back button
                $(document).on('click', '[data-button-label]', function () {
                    // console.log('back button clicked');
                    $('.wf-ordering-menu').removeClass('hides');
                    $('#main-ingredient-customizer-information-parent').removeAttr('style').addClass('hide');
                    undoConditionFormattingChanges();
                });
                function undoConditionFormattingChanges() {
                    let $comboMealFormattingSelector = $('.right-col.combo-meal');
                    if ($comboMealFormattingSelector.length) {
                        $comboMealFormattingSelector.removeClass('combo-meal');
                    }
                    let $drinkAddonFormattingSelector = $('.right-col.formatting-classic-combo-drink-addon');
                    if ($drinkAddonFormattingSelector.length) {
                        $drinkAddonFormattingSelector.removeClass('formatting-classic-combo-drink-addon');
                    }
                    let $addAccordianConditionalFormattingSelector = $('.right-col.formatting-add-accordian');
                    if ($addAccordianConditionalFormattingSelector.length) {
                        $addAccordianConditionalFormattingSelector.removeClass('formatting-add-accordian');
                    }
                    let $bigGameBundleComboConditionalFormattingSelector = $('.right-col.formatting-big-game-bundle');
                    if ($bigGameBundleComboConditionalFormattingSelector.length) {
                        $bigGameBundleComboConditionalFormattingSelector.removeClass('formatting-big-game-bundle');
                    }
                    let $classicComboConditionalFormattingSelectorWings = $('.right-col.formatting-classic-combo-wings');
                    if ($classicComboConditionalFormattingSelectorWings.length) {
                        $classicComboConditionalFormattingSelectorWings.removeClass('formatting-classic-combo-wings');
                    }
                    let $classicComboConditionalFormattingSelectorDrinkAddon = $('.right-col.formatting-classic-combo-drink-addon');
                    if ($classicComboConditionalFormattingSelectorDrinkAddon.length) {
                        $classicComboConditionalFormattingSelectorDrinkAddon.removeClass('formatting-classic-combo-drink-addon');
                    }
                    let $classicComboConditionalFormattingSelectorCheesesteak = $('.right-col.formatting-classic-combo-cheesesteak');
                    if ($classicComboConditionalFormattingSelectorCheesesteak.length) {
                        $classicComboConditionalFormattingSelectorCheesesteak.removeClass('formatting-classic-combo-cheesesteak');
                    }
                    let $classicComboConditionalFormattingSelector = $('.right-col.formatting-classic-combo');
                    if ($classicComboConditionalFormattingSelector.length) {
                        $classicComboConditionalFormattingSelector.removeClass('formatting-classic-combo');
                    }

                    let $wingsConditionalFormattingSelector = $('.right-col.formatting-30-50-pc-wings');
                    let $wingsConditionalFormattingSelectorForS = $('.right-col.formatting-30-50-pc-wings-with-s');
                    if ($wingsConditionalFormattingSelector.length) {
                        $wingsConditionalFormattingSelector.removeClass('formatting-30-50-pc-wings');
                    }
                    if ($wingsConditionalFormattingSelectorForS.length) {
                        $wingsConditionalFormattingSelector.removeClass('formatting-30-50-pc-wings-with-s');
                    }

                    // let $comboConditionalFormattingSelector = $('.product-detail-view-wrap.show-combo-popup-alert');
                    // if ($comboConditionalFormattingSelector.length) {
                    //   $comboConditionalFormattingSelector.removeClass('show-combo-popup-alert');
                    // }
                }



                validateItemForm();

            },
        });

        // Add Menu Selections To Cart
        $("button#item-add-to-cart:not(:disabled)").click(function () {
            // alert('Add To Cart');
            counter = 0;
            // console.log('i add to cart');
            addItemToBasket();
        });

        // Update edited basket product
        $("button#item-add-to-cart-update:not(:disabled)").click(function () {
            // Update Cart Product
            // console.log('update item in basket');
            updateItemInBasket();
        });

        $backBtn = $(".close-product-view .menu-category-url");
        $backBtn.click(function () {
            counter = 0;
        });
    });

}